export const KN_BR_CONTEXT_QUOTE_FEATURE = 'kn-br-quote-context';

export interface KnBrQuoteContextState {
  quoteContext?: string;
}

export interface StateWithQuoteContext {
  [KN_BR_CONTEXT_QUOTE_FEATURE]: KnBrQuoteContextState;
}
